import React from 'react';
import {
  JobQuoteStatusTypes,
  JobStatusTypes,
  ReviewStatuses,
} from '../api/generated/enums';
import {JobSummaryDto} from '../api/generated/index.defs';

type StatusType = keyof JobSummaryDto | 'reviewInboxStatus';
type StatusValue = string;

export const getColorForStatus = (
  status: StatusType,
  value: StatusValue = '',
): string => {
  const colorMap: Partial<Record<StatusType, Record<StatusValue, string>>> = {
    status: {
      [JobStatusTypes.Evaluation]: '#4CAF50',
      [JobStatusTypes.Archiving]: '#FF9800',
      [JobStatusTypes['Closed - Archived']]: '#9E9E9E',
    },
    evaluationIsRepairable: {
      unk: '#FFC107',
      yes: '#4CAF50',
      no: '#F44336',
    },
    evaluationQuoteStatus: {
      [JobQuoteStatusTypes['Quote Pending']]: '#FFEB3B',
      [JobQuoteStatusTypes['Pending Approval']]: '#d5aaae',
      [JobQuoteStatusTypes['Quote Approved']]: '#4CAF50',
      [JobQuoteStatusTypes['Quote Rejected']]: '#F44336',
    },
    reviewStatus: {
      [ReviewStatuses['Pending Review']]: '#87CEFA',
      [ReviewStatuses['Review Completed']]: '#4169E1',
      [ReviewStatuses['Request More Information']]: '#FF8C00',
    },
    reviewInboxStatus: {
      [ReviewStatuses['Pending Review']]: '#4CAF50',
      [ReviewStatuses['Review Completed']]: '#9E9E9E',
      [ReviewStatuses['Request More Information']]: '#87CEFA',
    },
  };

  return `${colorMap[status]?.[value]}33` || 'transparent';
};

type HighlightProps = {
  color: string;
  children: React.ReactNode;
  condition?: boolean;
};

export const Highlight: React.FC<HighlightProps> = ({
  color,
  children,
  condition = true,
}) => {
  const highlightStyle = React.useMemo(
    () => (condition ? getSequenceStyles(color) : {}),
    [condition, color],
  );

  return <mark style={highlightStyle}>{children}</mark>;
};

const getSequenceStyles = (actionCodeColor: string) => {
  return {
    backgroundColor: `${actionCodeColor}`,
    padding: '0.1rem',
    borderRadius: '3px',
  };
};
